import React from "react"
import { Grid } from "../../components/Table"
import moment from "moment"
import { EmptyScreen } from "../../components/Empty"
import { Card, CardTitle } from "../../components/Card"
import { LoadingWithLabel } from "../../components/Loading"

const columns = [
  {
    id: 0,
    label: "Pergunta",
    field: "pergunta",
    width: "200px",
  },
  {
    id: 1,
    label: "Código",
    field: "codigo",
    width: "200px",
  },
  {
    id: 2,
    label: "Data",
    field: "data",
    width: "180px",
    cellRenderer: ({ value }) => (
      <div className="rgt-cell-inner rgt-text-truncate">
        {moment(new Date(parseInt(value))).format("DD/MM/YYYY")}
      </div>
    ),
  },
  {
    id: 3,
    label: "Média",
    field: "media",
    width: "180px",
  },
  {
    id: 4,
    label: "Limite Inferior",
    field: "limite",
    width: "180px",
    cellRenderer: ({ data }) => (
      <div className="rgt-cell-inner rgt-text-truncate">
        {data.media - data.std > 0 ? data.media - data.std : 0}
      </div>
    ),
  },
  {
    id: 5,
    label: "Resposta",
    field: "resposta",
    width: "180px",
  },
  {
    id: 6,
    label: "Limite Superior",
    field: "limite",
    width: "180px",
    cellRenderer: ({ data }) => (
      <div className="rgt-cell-inner rgt-text-truncate">{data.media + data.std}</div>
    ),
  },
  {
    id: 7,
    label: "Link",
    field: "link",
    width: "180px",
  },
]

const QualityScreen = ({ data, loading }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
      {loading ? (
        <Card className="no-border" style={{ height: 500 }}>
          <LoadingWithLabel colorSpinner="primary" labelLoading="Aguarde, Buscando dados..." />
        </Card>
      ) : data.length > 0 ? (
        <>
          <Card className="no-border">
            {/* <CardTitle title="Dados com resposta" className="flex-start" /> */}
            <Grid
              onRowClick={({ data }) => window.open(data.link, "_blank")}
              rows={data}
              columns={columns}
            />
          </Card>
          {/* <Card className="no-border">
            <CardTitle title="Dados sem resposta" className="flex-start" />
            <Grid
              onRowClick={({ data }) => window.open(data.link, "_blank")}
              rows={data?.filter((item) => item?.resposta == 0)}
              columns={columns}
            />
          </Card> */}
        </>
      ) : (
        <Card className="no-border" style={{ height: 500 }}>
          <EmptyScreen label="Não há dados para mostrar" />
        </Card>
      )}
    </div>
  )
}

export default QualityScreen
